export default "__VITE_ASSET__Dc564bqK__"